export const environment = {
  production: true,
  api: {
    protocol: 'https://',
    hostname: 'sam.gfrmservices.com',
    path: '/v1/api/'
  },
  wordpress: {
    protocol: 'https://',
    hostname: 'samcms.wpengine.com',
    path: '/wp-json/wp/v2/'
  }
};



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/environments/environment.ts